import { storageAvailable } from '@/src/helpers'

const disableSimplifiedInterface = function({ commit }) {
  storageAvailable('localStorage') && localStorage.setItem("simplified-interface-hidden", true);
  commit('disableSimplifiedInterface');
};

export { disableSimplifiedInterface };
